export const GALLERY_IMAGE_SIZES = {
  medium: `calc(50vw - ${2 * 5.34}rem)`,
  base: `calc(100vw - ${2 * 3}rem)`
}

// fallback image sizes for browsers which don't support responsive images
export const FALLBACK_STICKY_BUYBOX_IMAGE_SIZE = 50
export const FALLBACK_GALLERY_THUMBNAIL_IMAGE_SIZE = 75
export const FALLBACK_GALLERY_IMAGE_SIZE = 318
export const FALLBACK_GALLERY_MODAL_IMAGE_SIZE = 2000
